export default class IUpdater {
    // eslint-disable-next-line no-unused-vars
    update(display) {
        throw 'Not implemented';
    }
}